import { useEffect } from 'react';
import { PAGE_LOAD } from '../components/analytics/events';
import { dispatchImmediateAnalyticsEvent } from '../components/analytics/analyticsEvents';

// This tests for the presence of Ensighten Bootstrap code before triggering analytics. see ESI tag in _document.jsx

const analyticsReady = () => {
  return (
    window && window.Bootstrapper && window.Bootstrapper.dataStateChangeReady
  );
};

export const usePageLoadReady = () => {
  useEffect(() => {
    if (analyticsReady()) {
      dispatchImmediateAnalyticsEvent(PAGE_LOAD);
    } else {
      document.body.addEventListener(
        'EnsightenReady',
        () => dispatchImmediateAnalyticsEvent(PAGE_LOAD),
        { once: true }
      );
    }
  }, []);
};
